module.exports = __webpack_public_path__ + "6dfe0f621b9327a25cc71c1b1426fdd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/AccessPlace - Home.png
// module id = 1032
// module chunks = 0